 <template>

  <v-card class="chat-room">
    <vue-perfect-scrollbar
      v-bind:class="[ editorVisible   == true ? 'chat-room--scroll grey lighten-5' : 'chat-room--scrollnoeditor grey lighten-5']"
      v-bind:style="computeHeight"
    >
      <v-card-text class="chat-room--list pa-3">
        <app-section-loader :status="commentloader"></app-section-loader>
        <v-list three-line="">
          <v-list-group
            v-for="(item,mainkey) in taskComments"
            :key="mainkey"
            no-action
          >
            <v-list-tile
              slot="activator"
              :key="mainkey"
              avatar
            >

              <v-avatar class="primary mx-1 white--text">{{ item.addedByUser.slice(0, 2).toUpperCase() }}</v-avatar>

              <v-list-tile-content>
                <div class="container pl-0">
                  <div class="layout row">
                    <div class="layout column flex lg9">
                      <div class="flex lg4 sm12 xs12"> {{item.addedByUser}}</div>
                      <v-list-tile-sub-title><span v-if="item.isEdited">
                          <v-icon small>edit </v-icon>
                        </span>
                        <div v-html="item.comment"> </div>
                      </v-list-tile-sub-title>

                    </div>

                    <div class="layout column flex lg2">
                      <v-spacer> </v-spacer>
                      <div class="flex"> {{ new Date(item.commentedDate).toLocaleString() }} </div>
                    </div>
                    <!-- <div class="layout column flex lg1">
                     
                    </div> -->

                  </div>

                </div>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-menu
                  bottom
                  left
                >
                  <v-btn
                    slot="activator"
                    icon
                  >
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile
                      v-for="(menuitem,index) in items"
                      :to="!menuitem.href ? { name: menuitem.name } : null"
                      :href="menuitem.href"
                      @click="maincomment(index, item,item)"
                      ripple="ripple"
                      :disabled="item.commentedBy != userId"
                      :target="menuitem.target"
                      rel="noopener"
                      :key="index"
                    >
                      <v-list-tile-action v-if="menuitem.icon">
                        <v-icon>{{ menuitem.icon }}</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-title>{{ menuitem.title }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-list-tile-action>

            </v-list-tile>
            <v-divider></v-divider>
            <v-list-tile
              v-for="(subItem,subindex) in item.taskCommentModels"
              :key="subindex"
            >
              <v-avatar class="primary mx-1 white--text">{{ subItem.addedByUser.slice(0, 2).toUpperCase() }}</v-avatar>

              <v-list-tile-content>
                <div class="container pl-0">
                  <div class="layout row">
                    <div class="layout column flex lg9">
                      <div class="flex lg4 sm12 xs12"> {{subItem.addedByUser}}</div>
                      <v-list-tile-sub-title><span v-if="subItem.isEdited">
                          <v-icon small>edit </v-icon>
                        </span>
                        <div v-html="subItem.comment"> </div>
                      </v-list-tile-sub-title>
                    </div>

                    <div class="layout column flex lg2">
                      <v-spacer> </v-spacer>
                      <div class="flex"> {{ new Date(subItem.commentedDate).toLocaleString() }} </div>
                    </div>

                  </div>
                </div>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-menu
                  bottom
                  left
                >
                  <v-btn
                    slot="activator"
                    icon
                  >
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile
                      v-for="(menuitem,index) in items"
                      :to="!menuitem.href ? { name: menuitem.name } : null"
                      :href="menuitem.href"
                      @click="maincomment(index, subItem,item)"
                      ripple="ripple"
                      :disabled="subItem.commentedBy != userId"
                      :target="menuitem.target"
                      rel="noopener"
                      :key="index"
                    >
                      <v-list-tile-action v-if="menuitem.icon">
                        <v-icon>{{ menuitem.icon }}</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-title>{{ menuitem.title }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider></v-divider>
            <v-text-field
              full-width
              flat
              solo
              v-model="subcomment.comment"
              clearable
              label="Type some message here & click enter"
            >
              <template slot="append">
                <v-icon
                  v-hotkey="sendsubKey"
                  @click="sendSubComment(item)"
                >send</v-icon>
                <!-- <v-icon @click="">attach_file</v-icon> -->
              </template>
            </v-text-field>
            <v-divider></v-divider>
          </v-list-group>
        </v-list>
      </v-card-text>
    </vue-perfect-scrollbar>

    <v-card-actions v-if="editorVisible == true">
      <!-- <v-text-field
        full-width
        flat
        solo
        v-model="taskcomment.comment"
        label="Type some message here & click enter"
      >
        <template slot="append">
          <v-icon
            @click="sendComment"
            v-hotkey="sendKey"
          >send</v-icon>
          
        </template>
      </v-text-field> -->
      <v-flex
        lg11
        sm11
      >
        <editor
          v-model="taskcomment.comment"
          :options="editorOptions"
          :html="editorHtml"
          :visible="editorVisible"
          previewStyle="vertical"
          mode="wysiwyg"
          height="200px"
        >

        </editor>

      </v-flex>
      <v-flex
        lg1
        sm1
      >
        <v-icon @click="sendComment">send</v-icon>
      </v-flex>
    </v-card-actions>
    <!-- <v-dialog
      v-model="taskmodel"
      max-width="800px"
      scrollable
      fullscreen
    >
      <v-card>
        <v-layout
          row
          wrap
        >

          <v-flex
            lg4
            sm4
          >
            <v-text-field
              label="Main Task Name"
              prepend-icon="tune"
              v-model="formdata.title"
              required
              :rules="formdata.requiredfield"
            ></v-text-field>
          </v-flex>
          <v-flex
            lg4
            sm4
          >
            <v-text-field
              label="From"
              v-model="formdata.addedByUser"
              prepend-icon="person"
              required
            ></v-text-field>
          </v-flex>

          <v-flex
            sm2
            lg2
          >
            <v-autocomplete
              hint="Atleast 3 Characters required"
              :loading="loader"
              flat
              :items="userItems"
              v-model="formdata.onBehalfID"
              label="OnBehalf"
              chips
              prepend-icon="people"
              item-text="userName"
              item-value="userID"
            ></v-autocomplete>
          </v-flex>
          <v-flex
            sm2
            lg2
          >

            <v-radio-group
              prepend-icon="verified_user"
              v-model="formdata.followUp"
            >
              <v-radio
                label="Follow up"
                value="true"
              ></v-radio>
              <v-radio
                label="No Follow up"
                value="false"
              ></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex
            sm4
            lg4
          >
            <v-autocomplete
              hint="Atleast 3 Characters required"
              :loading="loader"
              :items="userItems"
              v-model="formdata.assignedCC"
              label="CC"
              chips
              multiple
              prepend-icon="person_add"
              item-text="userName"
              item-value="userID"
            >
              <template
                slot="selection"
                slot-scope="data"
              >
                <v-chip
                  :selected="data.selected"
                  close
                  class="chip--select-multi"
                  @input="removeCC(data.item)"
                >
                  <v-avatar
                    class="primary white--text"
                    v-text="data.item.userName.slice(0, 1).toUpperCase()"
                  ></v-avatar>
                  {{ data.item.userName }}
                </v-chip>
              </template>
              <template
                slot="item"
                slot-scope="data"
              >
                <template v-if="typeof data.item !== 'object'">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
                <template v-else>
                
                  <v-list-tile-content>
                    <v-list-tile-title v-html="data.item.userName"></v-list-tile-title>
                   
                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
          </v-flex>

          <v-flex
            sm2
            lg2
          >

            <v-autocomplete
              hint="Atleast 3 Characters required"
              :loading="loader"
              flat
              :items="userItems"
              v-model="formdata.assignedTo"
              label="Assigned To"
              chips
              prepend-icon="perm_identity"
              required
              :rules="formdata.requiredfield"
              item-text="userName"
              item-value="userID"
            ></v-autocomplete>
          </v-flex>
          <v-flex
            sm2
            lg2
          >

            <v-menu
              :close-on-content-click="false"
              v-model="menudue"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="formdata.dueDate"
                label="Due Date"
                prepend-icon="event"
                readonly
                type="date"
              ></v-text-field>
              <v-date-picker
                v-model="formdata.dueDate"
                @input="menudue = false"
              ></v-date-picker>
            </v-menu>

          </v-flex>
          <v-flex
            sm2
            lg2
          >
            <v-checkbox
              v-model="formdata.overDueAllowed"
              label="Overdue not allowed"
              value="True"
            ></v-checkbox>
          </v-flex>
          <v-flex
            sm3
            lg3
          >
            <v-autocomplete
              hint="Atleast 3 Characters required"
              :loading="loader"
              flat
              :items="projectItems"
              v-model="formdata.projectID"
              label="Project"
              chips
              prepend-icon="pages"
              required
              item-text="name"
              item-value="projectID"
              @change="selectProject"
            >
              <template
                slot="selection"
                slot-scope="data"
              >
                <v-chip
                  :selected="data.selected"
                  close
                  class="chip--select-multi"
                  @input="removeProject(data.item)"
                >
                  <v-avatar
                    class="primary white--text"
                    v-text="data.item.name.slice(0, 1).toUpperCase()"
                  ></v-avatar>
                  {{ data.item.name }}
                </v-chip>
              </template>
              <template
                slot="item"
                slot-scope="data"
              >
                <template v-if="typeof data.item !== 'object'">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
                <template v-else>
                 
                  <v-list-tile-content>
                    <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                   
                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex
            sm3
            lg3
          >
            <v-autocomplete
              hint="Atleast 3 Characters required"
              :loading="loader"
              flat
              :items="tagItems"
              v-model="formdata.tagIds"
              label="Tag"
              chips
              multiple
              prepend-icon="local_offer"
              item-text="name"
              item-value="tagMasterID"
            >
              <template
                slot="selection"
                slot-scope="data"
              >
                <v-chip
                  :selected="data.selected"
                  close
                  class="chip--select-multi"
                  @input="removeTag(data.item)"
                >
                  <v-avatar
                    class="primary white--text"
                    v-text="data.item.name.slice(0, 1).toUpperCase()"
                  ></v-avatar>
                  {{ data.item.name }}
                </v-chip>
              </template>
              <template
                slot="item"
                slot-scope="data"
              >
                <template v-if="typeof data.item !== 'object'">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
                <template v-else>
               
                  <v-list-tile-content>
                    <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                    
                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex
            sm3
            lg3
          >

            <v-combobox
              v-model="formdata.personaltagIds"
              :items="personalTags"
              label="Personal Tag"
              multiple
              prepend-icon="filter_vintage"
            >
              <template
                slot="selection"
                slot-scope="data"
              >
                <v-chip
                  :selected="data.selected"
                  close
                  class="chip--select-multi"
                  @input="removePTag(data.item)"
                >
                  <v-avatar
                    class="primary white--text"
                    v-text="data.item.slice(0, 1).toUpperCase()"
                  ></v-avatar>
                  {{ data.item }}
                </v-chip>
              </template>
              <template
                slot="item"
                slot-scope="data"
              >
                <template v-if="typeof data.item !== 'object'">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
                <template v-else>
                 
                  <v-list-tile-content>
                    <v-list-tile-title v-html="data.item"></v-list-tile-title>
                   
                  </v-list-tile-content>
                </template>
              </template>
            </v-combobox>

          </v-flex>
          <v-flex
            sm3
            lg3
          >
            <v-autocomplete
              flat
              :items="taskStatus"
              v-model="formdata.statusCodeID"
              label="Status"
              chips
              prepend-icon="beenhere"
              required
              :rules="formdata.requiredfield"
              item-text="status"
              item-value="statusCodeID"
            >
              <template
                slot="selection"
                slot-scope="data"
              >
                <v-chip
                  :selected="data.selected"
                  close
                  class="chip--select-multi"
                  @input="removeStatus(data.item)"
                >
                  <v-avatar
                    class="primary white--text"
                    v-text="data.item.status.slice(0, 1).toUpperCase()"
                  ></v-avatar>
                  {{ data.item.status }}
                </v-chip>
              </template>
              <template
                slot="item"
                slot-scope="data"
              >
                <template v-if="typeof data.item !== 'object'">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
                <template v-else>
                  
                  <v-list-tile-content>
                    <v-list-tile-title v-html="data.item.status"></v-list-tile-title>
                   
                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex
            lg12
            sm12
          >
          
            <p> Main Task Description</p>
            <quill-editor
              class="quill"
              :content="formdata.description"
              :options="editorOption"
              v-model="formdata.description"
              aria-placeholder="Main task Content here..."
            >
            </quill-editor>
           

            </br>
           
            </br></br></br>
          </v-flex>
          <v-flex
            sm2
            lg2
          >
            <v-btn
              color="primary"
              @click="openUpload"
            >Upload</v-btn>
          
          </v-flex>
         
        </v-layout>

        
      </v-card>
    </v-dialog> -->
    <v-dialog
      v-model="subdialog"
      max-width="800px"
      @close="closeDial"
    >

      <v-card>

        <v-card-title>
          <span class="headline">{{formdata.formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <sub-task ref="refsubTaskForm"></sub-task>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            outline
            @click="subdialog = false"
          >Cancel</v-btn>
          <v-btn
            color="primary darken-1"
            outline
            @click.native="save"
          >Save</v-btn>
        </v-card-actions>
        <!-- <delete-confirmation-dialog
            ref="formdeleteConfirmationDialog"
            heading="Are You Sure You Want To Delete?"
            message="Are You Sure You Want To Delete This Item Permanently?"
            @onConfirm="formDeleteItem"
          >
          </delete-confirmation-dialog> -->
      </v-card>
    </v-dialog>

  </v-card>

</template>
<script>
//import TaskForm from '@/pages/task/taskForm';
import GlobalMessage from '@/constant'
import SubTask from '@/pages/task/subtask';
import { getSubTasksId, getTaskTreeId, getUserGroups, getTaskMastersbyID } from '@/api/taskMaster';
import Editor from '@toast-ui/vue-editor/src/editor.vue'
import { createTaskMaster, closeTask, getTaskComments, getApplicationUsers, createTaskComments, updateTaskComment, deleteTaskComment } from '@/api/taskMaster';
export default {
  components: {
    SubTask,
    Editor
  },
  data: () => ({

    timer: '',
    editorOptions: {
      hideModeSwitch: true
    },
    editorHtml: '',
    editorVisible: true,

    userItems: [],
    taskmodel: false,
    subdialog: false,
    commentloader: false,
    showreplytext: false,
    height: {
      type: String,
      default: null,
    },
    formdata: {
      valid: false,
      formTitle: '',
      taskID: -1,
      date: new Date().toISOString().substr(0, 10),
      title: '',
      assignedTo: null,
      dueDate: new Date().toISOString().substr(0, 10),
      description: '',
      projectID: null,
      assignedCC: [],
      assignedRights: [],
      onBehalfID: null,
      sessionID: '',
      addedByUserID: 1,
      addedDate: new Date().toISOString().substr(0, 10),
      addedByUser: 'Arun',
      statusCodeID: 511,
      statusCode: 'Active',
      modifiedByUserID: 1,
      modifiedDate: new Date().toISOString().substr(0, 10),
      requiredfield: [v => !!v || 'This is required field'],
      tagMasterID: -1,
      tagIds: [],
      personaltagIds: [],
      addedByUser: 'Arun',
      attachments: [],
      documentID: -1,
      documentAccessID: null,
      documentAccessName: null,
      sessionID: null,
      linkID: null,
      isSpecialFile: true,
      isTemp: true,
      description: '',
      uploadedFile: null,
      onBehalfName: '',
      overDueAllowed: 'false',
      followUp: 'false',
    },
    defaultData: {
      valid: false,
      taskID: -1,
      date: new Date().toISOString().substr(0, 10),
      title: '',
      assignedTo: null,
      dueDate: new Date().toISOString().substr(0, 10),
      description: '',
      projectID: null,
      assignedCC: [],
      onBehalfID: null,
      sessionID: '',
      addedByUserID: 1,
      addedDate: new Date().toISOString().substr(0, 10),
      addedByUser: 'Arun',
      statusCodeID: 511,
      statusCode: 'Active',
      modifiedByUserID: 1,
      modifiedDate: new Date().toISOString().substr(0, 10),
      requiredfield: [v => !!v || 'This is required field'],
      tagMasterID: -1,
      tagIds: [],
      personaltagIds: [],
      addedByUser: 'Arun',
      attachments: [],
      documentID: -1,
      documentAccessID: null,
      documentAccessName: null,
      sessionID: null,
      linkID: null,
      isSpecialFile: true,
      isTemp: true,
      description: '',
      uploadedFile: null,
      onBehalfName: '',
      overDueAllowed: 'false',
      followUp: 'false',
    },

    dueDate: new Date(),
    tagItems: [],
    projectItems: [],
    userItems: [],
    userGroupItems: [],
    cCItems: [],
    items: [],
    taskItems: [],
    taskItemLink: [],
    allFiles: [],
    uploadedFiles: [],
    showDownLoad: false,
    subtagItems: [],
    subprojectItems: [],
    subuserItems: [],
    subitems: [],
    subtaskItems: [],
    subtaskItemLink: [],
    suballFiles: [],
    subuploadedFiles: [],
    taskComments: [],
    taskcomment: { comment: '', taskMasterId: null, addedByUser: '', commentedDate: new Date(), taskCommentID: -1 },
    subcomment: { comment: '', taskMasterId: null, addedByUser: '', commentedDate: new Date(), taskCommentID: -1 },
    taskID: -1,
    mainItem: [],
    subItem: [],
    taskType: 'Main',
    items: [
      {
        icon: 'edit',
        href: '#',
        title: 'Edit',
        click: e => {


        }
      },
      {
        icon: 'delete',
        href: '#',
        title: 'Delete',
        click: e => {
          //  this.deleteComment(e);
        }
      },
      {
        icon: 'close',
        href: '#',
        title: 'Close Task',
        click: e => {
          //  this.deleteComment(e);
        }
      },
      {
        icon: 'tune',
        href: '#',
        title: 'Convert As Task',
        click: e => {

        }
      },
      {
        icon: 'tune',
        href: '#',
        title: 'Convert As Subtask',
        click: e => {

        }
      }
    ],
    userId: -1,
    editorOption: {
      // theme: 'bubble',
      // placeholder: "Main description",
      // modules: {
      //   toolbar: [
      //     ['bold', 'italic', 'underline', 'strike'],
      //     [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      //     [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      //     [{ 'color': [] }, { 'background': [] }],
      //     [{ 'font': [] }],
      //     [{ 'align': [] }],
      //     ['link', 'image'],
      //     ['clean']
      //   ]
      // }
    },
    task:
      {
        description: '',
        assignedTo: null,
        title: '',
        addedByUserID: null,
        addedDate: new Date(),
        statusCodeID: 511,
        parentTaskID: null,
        overDueAllowed: false,
        followUp: false,
        dueDate: new Date(),
      },
    tasktriggered: false,
    mainTaskId: null,
  }),
  watch: {
    subdialog (val) {
      val || this.closeDial();
    },
  },
  created () {

    window.getApp.$on('INITIALIZE_TASKCONVER', task => {
      this.taskID = task.taskID;
      this.mainTaskId = task.mainTaskId;
      this.initialize();
    });
    this.userId = this.$store.state.auth.userId;
    window.getApp.$on('SAVE_TASK', () => {
      this.save();
    });
    this.timer = setInterval(this.getMessages, 30000)
  },
  beforeDestroy () {
    clearInterval(this.timer);
  },
  computed: {
    computeHeight () {
      return {
        height: this.height || ''
      };
    },
    computeDisabled: function () {
      return (this.taskcomment.comment.length == 0);
    },
    menuDisabled: function () {
      return false;
    },
    sendKey () {

      return {
        // bind to hotkey 
        'enter': this.sendComment
      }
    },
    sendsubKey () {

      return {
        // bind to hotkey 
        'ctrl+enter': this.sendSubComment
      }
    },
  },
  methods: {
    createMessageTask () {
      console.log(this.task);
      createTaskMaster(this.task)
        .then(response => {
          this.task = response.data;
          window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.SAVE);
          this.taskmodel = false;
          this.subdialog = false;
        })
        .catch(error => {

          window.getApp.$emit('APP_API_ERROR', error);
        });

    },
    maincomment (key, item, mainItem) {
      this.mainItem = mainItem;
      this.subItem = item;
      if (key == 0) {

        if (item.parentCommentId == null) {
          this.taskcomment.comment = item.comment;
          this.taskcomment.taskCommentID = item.taskCommentID;
          this.editorVisible = true;
        }
        else {
          this.subcomment.comment = item.comment;
          this.subcomment.taskCommentID = item.taskCommentID;
          // this.updatesubComment();
        }
      }
      else if (key == 1) {
        this.deleteComment(item, mainItem);
      }
      else if (key == 3) {
        this.subdialog = true;
        this.formdata.formTitle = "Task"
        this.formdata.description = item.comment
        this.formdata.addedByUserID = this.$store.state.auth.userId;
        this.$refs.refsubTaskForm.formdata = this.formdata;
      }
      else if (key == 4) {
        // this.editSubTask(item);
        this.subdialog = true;
        this.formdata.formTitle = "Sub Task"
        this.formdata.description = item.comment;
        this.formdata.parentTaskID = this.taskID;
        this.formdata.addedByUserID = this.$store.state.auth.userId;
        this.$refs.refsubTaskForm.parentTaskID = this.taskID;
        this.$refs.refsubTaskForm.formdata = this.formdata;
      }
      else {
        this.closeTask(item.taskMasterID, item.commentedBy);
      }
    },
    showReply () {
      this.showreplytext = true;

    },
    initialize () {
      if (this.taskID > 0) {
        this.commentloader = true;
        let userId = this.$store.state.auth.userId;
        getTaskComments(this.taskID)
          .then(response => {
            this.taskComments = response.data;
            this.commentloader = false;
            let commented = this.taskComments.filter(f => f.commentedBy == userId);
            console.log(userId);

            if (commented.length > 0) {
              this.editorVisible = false;
            }
            else { this.editorVisible = true; }
          })
          .catch(error => {
            this.commentloader = false;
            window.getApp.$emit('APP_API_ERROR', error);
          });
        getApplicationUsers('')
          .then(response1 => {
            this.userItems = response1.data;
            this.commentloader = false;

          })
          .catch(error => {
            this.commentloader = false;
            window.getApp.$emit('APP_API_ERROR', error);
          });
        getUserGroups('')
          .then(response2 => {
            this.userGroupItems = response2.data;

            this.loader = false;

          })
          .catch(error => {
            this.loader = false;
            window.getApp.$emit('APP_API_ERROR', error);
          });
      }
      else {
        this.taskComments = [];
      }
    },
    getMessages () {
      let userId = this.$store.state.auth.userId;
      getTaskComments(this.taskID)
        .then(response => {
          this.taskComments = response.data;
          this.commentloader = false;
          let commented = this.taskComments.filter(f => f.commentedBy == userId);
          if (commented.length > 0) {
            this.editorVisible = false;
          }
          else { this.editorVisible = true; }
        })
        .catch(error => {
          this.commentloader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    sendComment () {

      if (this.taskcomment.comment.trim().length > 0) {
        this.commentloader = true;
        this.editorVisible = false;
        this.taskcomment.taskMasterId = this.taskID;
        this.taskcomment.commentedBy = this.$store.state.auth.userId;
        this.taskcomment.addedByUser = this.$store.state.auth.userName;
        this.taskcomment.commentedDate = new Date();
        if (this.taskcomment.taskCommentID > 0) {
          this.updateComment();
        }
        else {
          createTaskComments(this.taskcomment)
            .then(response => {

              this.taskComments.push(response.data);
              this.taskcomment.comment = '';
              this.commentloader = false;
            })
            .catch(error => {
              this.commentloader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });
        }
      }
    },
    sendSubComment (mainComment) {

      if (this.subcomment.comment.trim().length > 0) {
        this.commentloader = true;
        this.subcomment.taskMasterId = this.taskID;
        this.subcomment.parentCommentId = mainComment.taskCommentID;
        this.subcomment.commentedBy = this.$store.state.auth.userId;
        this.subcomment.addedByUser = this.$store.state.auth.userName;
        this.subcomment.commentedDate = new Date();
        if (this.subcomment.taskCommentID > 0) {
          this.updatesubComment(mainComment);

        }
        else {
          createTaskComments(this.subcomment)
            .then(response => {
              mainComment.taskCommentModels.push(response.data);

              //this.taskComments.push(response.data);
              this.subcomment.comment = '';
              this.commentloader = false;
            })
            .catch(error => {
              this.commentloader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });
        }
      }
    },
    updateComment () {

      if (this.taskcomment.comment.trim().length > 0) {
        this.commentloader = true;

        // this.taskcomment.taskMasterId = this.taskID;
        // this.taskcomment.commentedBy = this.$store.state.auth.userId;
        // this.taskcomment.addedByUser = this.$store.state.auth.userName;
        // this.taskcomment.commentedDate = new Date();

        updateTaskComment(this.taskcomment)
          .then(response => {
            this.mainItem.comment = this.taskcomment.comment;
            this.mainItem.isEdited = true;
            this.taskcomment.taskCommentID = -1;
            this.taskcomment.comment = '';
            this.commentloader = false;
          })
          .catch(error => {
            this.commentloader = false;
            window.getApp.$emit('APP_API_ERROR', error);
          });
      }
    },
    updatesubComment (mainComment) {

      if (this.subcomment.comment.trim().length > 0) {
        this.commentloader = true;

        // this.taskcomment.taskMasterId = this.taskID;
        // this.taskcomment.commentedBy = this.$store.state.auth.userId;
        // this.taskcomment.addedByUser = this.$store.state.auth.userName;
        // this.taskcomment.commentedDate = new Date();

        updateTaskComment(this.subcomment)
          .then(response => {
            this.subItem.comment = this.subcomment.comment;
            this.subItem.isEdited = true;
            this.subcomment.taskCommentID = -1;
            this.subcomment.comment = '';
            this.commentloader = false;
          })
          .catch(error => {
            this.commentloader = false;
            window.getApp.$emit('APP_API_ERROR', error);
          });
      }
    },
    deleteComment (item, mainItem) {

      deleteTaskComment(item)
        .then(response => {
          const index = mainItem.taskCommentModels.indexOf(item);
          mainItem.taskCommentModels.splice(index, 1);
          this.commentloader = false;
        })
        .catch(error => {
          this.commentloader = false;
          window.getApp.$emisubdialogt('APP_API_ERROR', error);
        });

    },
    editSubTask (item) {

      setTimeout(() => {
        window.getApp.$emit('SEND_TASKOBJ', this.formdata);
        window.getApp.$emit('EDIT_SUBTASK', item);
      }, 300);
      this.subdialog = true;
    },
    addSubTask (item) {
      console.log(item);

      setTimeout(() => {
        window.getApp.$emit('SEND_TASKOBJ', this.formdata);
        window.getApp.$emit('ADD_SUBTASK', item);
      }, 300);
      this.subdialog = true;
    },
    indexWhere (array, conditionFn) {
      const item = array.find(conditionFn)
      return array.indexOf(item)
    },
    downloadFile (key) {

      this.loader = true;
      downloadFile(this.formdata.attachments[key])
        .then(response => {
          let blob = new Blob([response.data], { type: this.editFile.contentType })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = this.editFile.name
          link.click()
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

    },

    save () {
      if (this.$refs.refsubTaskForm.$refs.validatesubform.validate()) {

        this.formdata = this.$refs.refsubTaskForm.formdata;
        this.loader = true;
        this.formdata.addedByUserId = this.$store.state.auth.userId;
        this.formdata.addedDate = new Date().toISOString().substr(0, 10);
        this.formdata.statusCodeID = 512;
        this.formdata.mainTaskId = this.mainTaskId;
        createTaskMaster(this.formdata)
          .then(response => {
            this.loader = false;
            this.formdata = response.data;
            window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.SAVE);
            this.subdialog = false;
            window.getApp.$emit('INITIALIZE_SUBTASK', this.mainTaskId);
            this.formdata = Object.assign({}, this.defaultData);
          })
          .catch(error => {
            this.loader = false;
            window.getApp.$emit('APP_API_ERROR', error);
          });

      }
      else {
        window.getApp.$emit('APP_API_VAL', GlobalMessage.VALIDATE);
      }
    },

    closeDial () {
      this.formdata = Object.assign({}, this.defaultData);
    },
    closeTask (taskId, userId) {
      let closeObje = {
        taskID: taskId,
        addedByUserID: userId,
        modifiedByUserID: this.$store.state.auth.userId,
      };
      closeTask(closeObje)
        .then(response => {
          this.task = response.data;
          window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.SAVE);

        })
        .catch(error => {
          window.getApp.$emit('APP_API_ERROR', error);
        });
    }
  }
};
</script>

<style lang="stylus" scoped>
.chat-room--scroll {
  height: calc(100vh - 120px - 110px);
}

chat-room--scrollnoeditor {
  height: calc(100vh - 48px - 80px);
}
</style>


// WEBPACK FOOTER //
// src/pages/task/taskConversation.vue